export const serializeFlatQueryParams = (
  params: Record<string, any>
): string => {
  const serializedParams = Object.entries(params)
    .filter(([, value]) => value !== undefined && value !== null)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: String(value) }), {});

  return new URLSearchParams(serializedParams).toString();
};
